import api from "api/axios";

export const fetchPavilionsTree = (payload) =>
  api.post(`/pavilion/search`, payload);

export const fetchOrganizerPavilions = (companyId) =>
  api.get(`/pavilion/company/${companyId}`);

export const fetchPavilionById = (id) =>
  api.get(`/pavilion/${id}`);

export const createPavilion = (data) =>
  api.post("/pavilion", data);

export const updatePavilion = (id, data) =>
  api.put(`/pavilion/${id}`, data);

export const deletePavilion = (id, payload) =>
  api.put(`/pavilion/delete/${id}`, payload);
